import {
    MetaDispatcher as SourceMetaDispatcher
} from 'SourceStore/Meta/Meta.dispatcher';
import { appendWithStoreCode } from 'Util/Url';

/** @namespace Elganso/Store/Meta/Dispatcher */
export class MetaDispatcher extends SourceMetaDispatcher {
    _getProductMeta(product) {
        const {
            name,
            meta_title,
            meta_keyword,
            canonical_url,
            description
        } = product;

        return {
            description: description?.html,
            keywords: meta_keyword || name,
            title: meta_title || name,
            canonical_url: `${window.location.origin}${appendWithStoreCode(canonical_url)}`
        };
    }
}

export default new MetaDispatcher();
